module.exports = __webpack_public_path__ + "img/stock1.b5ec42b7.png";